<div [formGroup]="form">
<div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">redeem</mat-icon>
        <span>Crédito Presumido Operação</span>
        <div class="section-title-actions ms-auto">
            <button mat-button type="button" class="btn-section" [matBadge]="personalizadasCount" [matBadgeHidden]="personalizadasCount === 0" (click)="abrirEditorFormulas()">
                <mat-icon class="material-symbols-outlined">settings</mat-icon>
                Personalizar fórmulas
            </button>
        </div>
    </div>

    <div class="row g-3">
        <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Código da operação</mat-label>
                <mat-select formControlName="cCredPres">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (opcao of codigos; track opcao.codigo) {
                    <mat-option [value]="opcao.codigo">{{ opcao.codigo }} - {{ opcao.descricao }}</mat-option>
                    }
                </mat-select>
                <mat-error>Informe o código do crédito presumido.</mat-error>
            </mat-form-field>
        </div>
    </div>
</div>
</div>
